import * as React from "react";
import { SVGProps } from "react";
const SvgInfo = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M27.247 7.9c-.301-1.6-1.506-2.8-3.113-3.1C21.423 4.3 18.71 4 16 4c-2.711 0-5.423.3-8.134.8-1.607.3-2.812 1.5-3.113 3.1-1.004 5.4-1.004 10.9 0 16.2.301 1.6 1.506 2.8 3.113 3.1 2.711.5 5.423.8 8.134.8 2.711 0 5.423-.3 8.134-.8 1.607-.3 2.812-1.5 3.113-3.1a43.934 43.934 0 0 0 0-16.2ZM17 22c0 .5-.5 1-1 1s-1-.5-1-1v-7c0-.5.5-1 1-1s1 .5 1 1v7Zm-1-10c-.8 0-1.5-.7-1.5-1.5S15.2 9 16 9s1.5.7 1.5 1.5S16.8 12 16 12Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgInfo;
